export default __webpack_public_path__ + "media/images/features/local_delivery/episode1/LP_02-e8f74dd7407342323b07fc788bfafccf.jpg";